module.exports = __webpack_public_path__ + "img/icon-cardapio-pro.cd27738c.png";